import DoorStickerOneForm from './DoorStickerOneForm';
import DoorStickerTwoForm from './DoorStickerTwoForm';

export default {
  DoorStickerOneForm,
  DoorStickerTwoForm,
};
